<template>
  <CoolLightBox
    :index="index"
    :items="items"
    :show-thumbs="true"
    :slideshow="false"
    :use-zoom-bar="false"
    @close="setLightboxIndex(null)"
    @on-open="open"
    ref="lightbox"
    thumbs-position="bottom"
  >
    <template v-slot:close><span class="icon-line-close" /></template>
    <template v-slot:icon-previous><span class="icon-chevron-left" /></template>
    <template v-slot:icon-next><span class="icon-chevron-right" /></template>
  </CoolLightBox>
</template>

<script>
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css';
import CoolLightBox from 'vue-cool-lightbox';
import lightbox from '~/mixins/lightbox';

export default {
  name: 'LightBox',
  components: {
    CoolLightBox,
  },
  mixins: [lightbox],
  methods: {
    open() {
      setTimeout(() => {
        this.$refs.lightbox.showThumbs = true;
      }, 1);
    },
  },
};
</script>

<style lang="scss">
.cool-lightbox {
  background-color: $cWhite !important;
}

.cool-lightbox .cool-lightbox__slide img {
  box-shadow: none !important;
}

.cool-lightbox .cool-lightbox-thumbs .cool-lightbox-thumbs__list .cool-lightbox__thumb:before {
  border: 2px solid $cSec !important;
  border-radius: 5px !important;
}

.cool-lightbox .cool-lightbox-thumbs .cool-lightbox-thumbs__list .cool-lightbox__thumb img {
  width: auto !important;
  height: auto !important;
  object-fit: unset !important;
  max-width: 100% !important;
  max-height: 100% !important;
}

.cool-lightbox .cool-lightbox-thumbs .cool-lightbox-thumbs__list .cool-lightbox__thumb {
  background-color: $cWhite !important;
}

.cool-lightbox .cool-lightbox-thumbs {
  background-color: $cWhite !important;
}

.cool-lightbox-toolbar {
  button {
    &:first-child {
      display: none;
    }
  }
}

.cool-lightbox .cool-lightbox-thumbs .cool-lightbox-thumbs__list {
  padding: 0;
}

.cool-lightbox-toolbar .cool-lightbox-toolbar__btn {
  background-color: $cWhite;
  color: $cBlack;
  transition: color $tr;

  .icon-line-close {
    font-size: 2rem;
  }

  &:hover {
    color: $cSec;
  }
}

.cool-lightbox .cool-lightbox-button {
  color: $cBlack;
  transition: color $tr;

  .icon-chevron-right,
  .icon-chevron-left {
    font-size: 4rem;
  }

  &:hover {
    color: $cSec;
  }
}

.cool-lightbox.cool-lightbox--thumbs-bottom .cool-lightbox-thumbs {
  height: 75px;
}

.cool-lightbox.cool-lightbox--thumbs-bottom .cool-lightbox-thumbs::-webkit-scrollbar-thumb {
  border-radius: 10px;
  width: 5px;
  background-color: $cAddLight;
}

.cool-lightbox.cool-lightbox--thumbs-bottom .cool-lightbox-thumbs::-webkit-scrollbar-track {
  -webkit-box-shadow: 0;
  border-radius: 10px;
  background-color: transparent;
}
</style>
